import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SharedTreatExperimentMutation, SharedTreatExperimentMutationVariables } from './treatExperiment.graphql';
import { SharedTreatExperiment } from './treatExperiment.graphql';

/**
 * Treats an experiment by calling the GraphQL API.
 *
 * This should be awaited so that the treated state is registered on the server before any subsequent tracking event.
 */
export async function treatExperiment(utilityContext: UtilityContext, experimentName: string): Promise<void> {
	try {
		await utilityContext.gql.fetch<SharedTreatExperimentMutation, SharedTreatExperimentMutationVariables>({
			query: SharedTreatExperiment,
			variables: { experimentName },
			rejectOnError: true,
		});
	} catch (e) {
		// we don't want this to break the app, so we make it fail silently
		// error will still be reported by GqlClient
	}
}
